module.exports = __webpack_public_path__ + "img/price-primary.71f2b937.svg";